export enum ATTRIBUTE_TYPES {
    CHECKBOX = 'checkbox',
    INPUT = 'input',
    RADIO = 'radio',
    RATINGS = 'ratings',
    RICH_TEXT = 'richText',
    MARKDOWN_EDITOR = 'markdownEditor',
    SELECT = 'select',
    SLIDER = 'slider',
    TEXTAREA = 'textarea',
    TOGGLE = 'toggle',
    MULTI_TEXT = 'multiText',
    NUMBER = 'number',
    DATE = 'date',
    TIME = 'time',
    FILE = 'file',
}

export const DEFAULT_SELECTED_PATH = '$'
